import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { routeLogin } from "../../settings/routeConfig";
import logo from "../../img/logo.png";
import { MdMenu, MdClose, MdExpandMore } from "react-icons/md";

const NavItem = ({ label, to, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className="relative group"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <Link
                to={to}
                className="flex items-center gap-1 text-gray-300 hover:text-white font-medium px-3 py-2 transition-colors cursor-pointer"
            >
                {label} {children && <MdExpandMore />}
            </Link>

            {/* Dropdown Menu */}
            {children && (
                <div className={`absolute left-0 mt-0 w-56 bg-white rounded-md shadow-xl py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top-left z-50`}>
                    {children}
                </div>
            )}
        </div>
    );
};

const DropdownItem = ({ label, to }) => (
    <Link to={to} className="block px-4 py-2 text-sm text-gray-700 hover:bg-amber-50 hover:text-amber-700 transition-colors">
        {label}
    </Link>
);

const LandingNavbar = () => {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleLogin = () => navigate(routeLogin);

    return (
        <nav className="fixed top-0 w-full z-50 transition-all duration-300 bg-gray-900/95 shadow-md py-2 backdrop-blur-sm border-b border-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center gap-3 cursor-pointer">
                        <img src={logo} alt="Atecma Logo" className="h-10 w-auto bg-white rounded p-1 shadow-sm" />
                        <span className="text-2xl font-bold text-white tracking-tight">ATECMA</span>
                    </Link>

                    {/* Desktop Menu */}
                    <div className="hidden lg:flex items-center gap-6">
                        <NavItem label="Inicio" to="/" />

                        <NavItem label="Quiénes Somos" to="/#quienes-somos" />

                        <NavItem label="SSMA" to="/ssma">
                            {/* Anchor links inside the page or subpages? User asked for separate pages. 
                        If SSMA is one page with sections, we can link to anchor. 
                        But user said "cada opcion tiene que ser una pestaña nueva". 
                        I will make SSMA a single page covering all points for now to avoid 20 files. 
                        Or I can make links jump to sections within the SSMA page.
                        Let's link to the main SSMA page for simplicity first. 
                     */}
                        </NavItem>

                        <NavItem label="Servicios" to="/servicios" />

                        <NavItem label="Experiencia" to="/experiencia" />

                        <NavItem label="Contacto" to="/contacto" />

                        <button
                            onClick={handleLogin}
                            className="ml-4 px-5 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-full transition-all shadow-lg hover:shadow-amber-600/30 transform hover:-translate-y-0.5"
                        >
                            Intranet
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="lg:hidden">
                        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white p-2">
                            {mobileMenuOpen ? <MdClose size={28} /> : <MdMenu size={28} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Content */}
            {mobileMenuOpen && (
                <div className="lg:hidden bg-gray-900 absolute top-full w-full border-t border-gray-800">
                    <div className="px-4 py-4 space-y-2 flex flex-col">
                        <Link to="/" className="block px-3 py-2 text-white font-medium" onClick={() => setMobileMenuOpen(false)}>Inicio</Link>
                        <Link to="/quienes-somos" className="block px-3 py-2 text-white font-medium" onClick={() => setMobileMenuOpen(false)}>Quiénes Somos</Link>
                        <Link to="/ssma" className="block px-3 py-2 text-white font-medium" onClick={() => setMobileMenuOpen(false)}>SSMA</Link>
                        <Link to="/servicios" className="block px-3 py-2 text-white font-medium" onClick={() => setMobileMenuOpen(false)}>Servicios</Link>
                        <Link to="/experiencia" className="block px-3 py-2 text-white font-medium" onClick={() => setMobileMenuOpen(false)}>Experiencia</Link>
                        <Link to="/contacto" className="block px-3 py-2 text-white font-medium" onClick={() => setMobileMenuOpen(false)}>Contacto</Link>
                        <button onClick={handleLogin} className="mt-4 w-full px-5 py-3 bg-amber-600 text-white font-bold rounded-lg">Intranet</button>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default LandingNavbar;
